import { render, staticRenderFns } from "./getSMSLinkList.vue?vue&type=template&id=1bcc6132&scoped=true&"
import script from "./getSMSLinkList.vue?vue&type=script&lang=js&"
export * from "./getSMSLinkList.vue?vue&type=script&lang=js&"
import style0 from "./getSMSLinkList.vue?vue&type=style&index=0&id=1bcc6132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc6132",
  null
  
)

export default component.exports